import { Clock, Gift, HeartHandshake } from "lucide-react";
import { IMAGES, PROBLEMS } from "../../lib/content";
import { Reveal } from "./Reveal";

const ICONS = [
  { Icon: Clock, tone: "bg-[#F8EFEA] text-[#C85A32]" },
  { Icon: Gift, tone: "bg-[#FAF3E8] text-[#B9823F]" },
  { Icon: HeartHandshake, tone: "bg-[#EAF0EC] text-[#536B5B]" },
];

export const SoundFamiliar = () => (
  <section id="sound-familiar" data-testid="sound-familiar-section" className="section bg-[#FDFBF7]">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 grid gap-14 lg:grid-cols-12 lg:gap-20 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="eyebrow">You're not alone</p>
          <h2 data-testid="sound-familiar-heading" className="section-title mt-4">Sound familiar?</h2>
        </Reveal>
        <Reveal delay={150} className="mt-10 hidden lg:block">
          <div className="photo-frame aspect-[4/5]">
            <img src={IMAGES.momLift.src} alt={IMAGES.momLift.alt} loading="lazy" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 flex flex-col gap-6">
        {PROBLEMS.map((text, i) => {
          const { Icon, tone } = ICONS[i];
          return (
            <Reveal key={text} delay={i * 140} className={i === 1 ? "lg:ml-12" : ""}>
              <article data-testid={`problem-card-${i + 1}`} className="warm-card flex items-start gap-6 p-7 sm:p-9">
                <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl ${tone}`}>
                  <Icon className="h-6 w-6" strokeWidth={1.75} />
                </span>
                <p className="font-serif text-xl sm:text-2xl leading-snug text-[#2C221E]">{text}</p>
              </article>
            </Reveal>
          );
        })}
        <Reveal delay={200} className="lg:hidden mt-4">
          <div className="photo-frame aspect-[4/3]">
            <img src={IMAGES.momLift.src} alt={IMAGES.momLift.alt} loading="lazy" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
